import { render, staticRenderFns } from "./order_divide.vue?vue&type=template&id=4e6160e4&v-loading=loading&element-loading-text=%E6%AD%A3%E5%9C%A8%E4%B8%8B%E8%BD%BD%E4%B8%AD&element-loading-spinner=el-icon-loading&element-loading-background=rgba(0%2C%200%2C%200%2C%200.8)"
import script from "./order_divide.vue?vue&type=script&lang=js"
export * from "./order_divide.vue?vue&type=script&lang=js"
import style0 from "./order_divide.vue?vue&type=style&index=0&id=4e6160e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports